import { render, staticRenderFns } from "./PeriodDetailApp.vue?vue&type=template&id=336c2e24&scoped=true"
import script from "./PeriodDetailApp.vue?vue&type=script&lang=js"
export * from "./PeriodDetailApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c2e24",
  null
  
)

export default component.exports